import React from 'react';

const Step6Form = ({ formData, handleOfferChange, handleNextStep }) => {
  return (
    <div>
      <h2>Step 4: Scheduling</h2>
      {/* Add your form fields and logic here */}
    </div>
  );
};

export default Step6Form;
